<template>
  <GridBase title-block :class="[type, dark ? 'dark' :'']" :dark="dark">
    <div title-block-content>
      <slot/>
    </div>
  </GridBase>
</template>
<script>
import GridBase from '@/views/components/GridBase';
export default {
  name: 'TitleBlock',
  components: { GridBase },
  props: {
    type: { default: 'h1' },
    dark: { default: false, type: Boolean },
  }
}
</script>

<style lang="less">
@import "~@/less/proj";

[title-block] { .keep-all;
  &.h1 [title-block-content]{ .p(60,20,30);
    .sub { .fs(18); .medium; }
    .title { .fs(54,1.04); .semi-bold; // .mt(10);
    }
  }
  &.dark { color:#fff; .bgc(#191919); }
}

@media (min-width: @screen-md-min) {
  [title-block] {
    &.h1 [title-block-content]{ .p(60,40,30);
      .sub { .fs(20); }
      .title { .fs(68,74,0); //.mt(15);
      }
    }
  }
}

@media (min-width: @screen-lg-min) {
  [title-block] {
    &.h1 [title-block-content]{ .w(50%); .ml(25%); .vw-p(90,20,40); .-box;
      .sub { .vw-fs(18); }
      .title { .vw-mt(10); .vw-fs(76,1.05); }
    }
  }
}

@media (min-width: @screen-xxl-min) {
  [title-block] {
    &.h1 [title-block-content]{ .w(1100); .mh-c; .p(150,0,60); .-box;
      .sub { .fs(32); }
      .title { .fs(120,130,0); //  .mt(30);
      }
    }
  }
}

</style>
